import { Checkbox } from '@/shared/ui/checkbox';

interface PriorityFilterListProps {
  isLoading: boolean;
  data: { id: number; name: string }[] | undefined;
  selected: string[];
  onChange: (next: string[]) => void;
}

export function PriorityFilterList({
  isLoading,
  data,
  selected,
  onChange,
}: PriorityFilterListProps) {
  if (isLoading) return <div className="text-sm text-muted-foreground">Loading...</div>;

  return (
    <div className="space-y-2">
      {(data ?? []).map(({ id, name }) => {
        const val = String(id);
        return (
          <label key={id} className="flex items-center gap-2 cursor-pointer">
            <Checkbox
              checked={selected.includes(val)}
              onCheckedChange={(checked) =>
                onChange(checked ? [...selected, val] : selected.filter((v) => v !== val))
              }
            />
            <span className="text-sm text-foreground">{name}</span>
          </label>
        );
      })}
    </div>
  );
}
